/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';

import { Box, CircularProgress, Container } from '@material-ui/core';

const LoadingScreen: React.FC = () => {
  return (
    <Container maxWidth="sm">
      <Box
        mt={8}
        display="flex"
        flexDirection="row"
        justifyContent="center"
        alignItems="center"
      >
        <CircularProgress aria-label="progress" />
      </Box>
    </Container>
  );
};

export default LoadingScreen;
